import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
    InputSignal,
    signal,
} from "@angular/core";
import { AppsStore } from "../../../stores/offers/apps.store";
import { ForYouStore } from "../../../stores/offers/for-you.store";
import { GamesStore } from "../../../stores/offers/games.store";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { MatExpansionModule } from "@angular/material/expansion";
import { OffersTableComponent } from "../offers-table/offers-table.component";
import { MatIcon } from "@angular/material/icon";
import { groupBy } from "../../../utils/array-utils";
import { MatSlideToggle, MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatButton } from "@angular/material/button";
import { MatDialog } from "@angular/material/dialog";
import { CreateOfferDialogComponent } from "../create-offer-dialog/create-offer-dialog.component";
import { ClientsStore } from "../../../stores/clients/client.store";
import { EMPTY, mergeMap } from "rxjs";
import { ClientViewModel } from "@playcharge/common/models/backend/clients/client-view-model";
import { CreateOfferEditModel } from "@playcharge/common/models/backend/offers/backoffice/create-offer-edit-model";
import { ToastrService } from "ngx-toastr";
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { ComponentRoutes } from "../../../models/constants/component-routes";

@Component({
    selector: "app-offers-tab",
    standalone: true,
    imports: [
        CommonModule,
        MatExpansionModule,
        OffersTableComponent,
        MatIcon,
        NgOptimizedImage,
        MatSlideToggle,
        MatButton,
    ],
    templateUrl: "./offers-tab.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OffersTabComponent {
    private _router = inject(Router);
    private _matDialog = inject(MatDialog);
    private _toastrService = inject(ToastrService);
    private _clientsStore = inject(ClientsStore);

    public offersStore: InputSignal<AppsStore | GamesStore | ForYouStore> = input.required<
        AppsStore | GamesStore | ForYouStore
    >();

    public icon: InputSignal<string> = input.required<string>();
    public title: InputSignal<string> = input.required<string>();

    public offers = computed(() => {
        return this.showArchived()
            ? this.offersStore().archivedEntities()
            : this.offersStore().entities();
    });
    public showArchived = signal<boolean>(false);

    public onOffersTypeToggled(event: MatSlideToggleChange): void {
        this.showArchived.set(event.checked);
    }

    public openCreateOfferDialog(): void {
        this._matDialog
            .open<CreateOfferDialogComponent, ClientViewModel[], CreateOfferEditModel>(
                CreateOfferDialogComponent,
                {
                    data: this._clientsStore.entities(),
                },
            )
            .afterClosed()
            .pipe(
                mergeMap((model) => {
                    if (model) {
                        return this.offersStore().createOffer(model);
                    } else {
                        return EMPTY;
                    }
                }),
            )
            .subscribe({
                next: (offer) => {
                    this._router.navigateByUrl(
                        ComponentRoutes.offers.offer.replace(":offerId", offer.id.toString()),
                    );

                    this._toastrService.success("Done");
                },
                error: (error: HttpErrorResponse) =>
                    this._toastrService.error(error?.error?.description ?? "Internal Error"),
            });
    }
}
